import { t } from '../../../i18n'
import { VALID_CLONE_COMPETITION_TYPES } from './constants'
import type { CloneCompetitionType, WizardFormValues } from './types'

/** Returns the value as a CloneCompetitionType when it's one of the known options, otherwise null. */
export const toCloneCompetitionType = (
  raw: string | null | undefined
): CloneCompetitionType | null =>
  raw && VALID_CLONE_COMPETITION_TYPES.includes(raw as CloneCompetitionType)
    ? (raw as CloneCompetitionType)
    : null

/**
 * Returns the tenant-aware word for "competition" (SportNinja: "competition",
 * Canlan: "season"), capitalised. Use `plural` for the plural form.
 */
export const competitionWord = ({
  plural = false,
  capitalize = true,
}: { plural?: boolean; capitalize?: boolean } = {}): string => {
  const text = t(
    plural ? 'common:competition_plural' : 'common:competition',
    {}
  )
  return capitalize ? t('util:capitalize', { text }) : text
}

/**
 * True when the wizard's Summary submit will route through /schedules/:id/clone
 * instead of /wizard/competition. Enhanced Playoffs always routes through
 * clone (no skip option). Simple Playoffs and Tournament route through clone
 * only when the user picked a source on Step 3 — without a source they walk
 * the regular 6-step new-create flow.
 */
export const isCloneShortCircuit = (values: WizardFormValues): boolean => {
  const type = values.competitionType
  if (type === 'playoffs_enhanced') {
    return true
  }
  if (type === 'playoffs_simple' || type === 'tournament') {
    return Boolean(values.cloneSource.sourceScheduleId)
  }
  return false
}
